export default __webpack_public_path__ + "static/media/feather-trash.f5691b8b.svg";